import { Grid, styled } from '@mui/material';
import { IconCompanies } from 'assets/img';
import { useCompanyRelativePath } from 'ogp/hooks';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { BlockLink, LwBlock } from 'redesign';
import { routes } from 'Routes';

export const ClientCard = ({
  serviceAgreement,
}: {
  serviceAgreement: ServiceAgreementsResponse[number];
}) => {
  const generatePath = useCompanyRelativePath();
  const clientName =
    serviceAgreement.serviceAgreementPartyRole === 'LENDER'
      ? serviceAgreement.borrowerServiceAgreementParty.name
      : serviceAgreement.lenderServiceAgreementParty.name;

  return (
    <Grid item xs={6} md={4} lg={3}>
      <BlockLink to={generatePath(routes.ServiceAgreementDetail, { id: serviceAgreement.id })}>
        <LwBlock
          severity="none"
          id={serviceAgreement.id}
          title={clientName}
          icon={<StyledIconCompanies />}
        />
      </BlockLink>
    </Grid>
  );
};

const StyledIconCompanies = styled(IconCompanies)(() => ({
  width: '24px',
  height: '24px',
}));
